import config from 'services/table/const';
import Action from './table.action';

let table = { ...config };

table.url = '/accounting/coa';
table.columns = {
  code: {
    title: '# Code',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.code}
          </div>
        </div>
      );
    },
  },

  name: {
    title: 'Name',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.name}
          </div>
        </div>
      );
    },
  },

  pos_saldo: {
    title: 'POS Saldo',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.pos_saldo}
          </div>
        </div>
      );
    },
  },

  pos_report: {
    title: 'POS Report',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.pos_report}
          </div>
        </div>
      );
    },
  },



  action: {
    title: '',
    sortable: false,
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
